import React, {useEffect, useState} from "react";
import {Button, InputGroup, Input, FormGroup, FormText, Spinner} from "reactstrap";
import logo from "resources/My ESP Logo white.svg";
import egg from "resources/egg.webp";
import {connect} from "react-redux";
import {loginUserAction} from "redux/actions/login-actions";
import "styles/General/Login.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAt, faKey, faUser} from "@fortawesome/free-solid-svg-icons";
import {useForm} from "react-hook-form";
import {forgotPassword} from "redux/actions/login-actions";
import {tryLogin} from "redux/actions/login-actions";
import {loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha} from "react-simple-captcha";
import {captcha} from "util/base64icons";
import "styles/General/Captcha.scss";
import {loginFailed} from "redux/actions/login-actions";
import {HashShortPassword} from "util/PasswordHasher";
import {resendConfirmEmail} from "redux/actions/login-actions";
import BrowserSignalR from "./BrowserSignalR";
import {useTranslation} from "react-i18next";

export default function Login(props) {
	const {t} = useTranslation();
	useEffect(() => {
		if (!props.loginReducer.loggingOut) props.tryLogin();
	}, []);
	const isError = props.loginReducer.errorMessage !== "";
	const untrustedBrowser = props.loginReducer.untrustedBrowser;
	const [forgot, setForgot] = useState(false);

	useEffect(() => {
		if (isError && !forgot) {
			loadCaptchaEnginge(5, "white", "red");
		}
	}, [isError, forgot]);
	const [count, setCount] = useState(1);
	const {
		register,
		formState: {errors},
		handleSubmit,
	} = useForm();

	useEffect(() => {
		if (props.loginReducer.forgotStatus === "") {
			setForgot(false);
		}
	}, [props.loginReducer.forgotStatus]);

	const onClick = () => {
		setCount(count + 1);
	};

	const handleForget = (data) => {
		props.forgotPassword(data.email);
	};

	const [credentials, setCredentials] = useState(null);

	const buttonDisabled = props.loginReducer.isLoggingIn;

	const handleLogin = (data) => {
		if (buttonDisabled) return;
		if (isError && !validateCaptcha(data.captcha)) {
			props.setError(t("Invalid captcha"));
			return;
		}
		let credentials = {
			login: data.login,
			password: HashShortPassword(data.password),
		};
		props.loginUser(credentials);
		setCredentials(credentials);
	};

	const resendEmail = () => {
		props.resendEmail();
	};

	const toggleForgot = () => {
		setForgot(!forgot);
	};

	return (
		<div id="login__wrapper">
			<div className="login__container">
				<div className="login__logo-container" onClick={onClick}>
					{count >= 15 ? <img src={egg} alt="logo" className="login__logo" /> : <img src={logo} alt="logo" className="login__logo" />}
				</div>
				{!forgot ? (
					untrustedBrowser ? (
						<div style={{color: "white", textAlign: "center"}}>
							<h5>{t("We need additional confirmation, email has been sent")}</h5>
							<span className="login__forgot-text" onClick={resendEmail}>
								{t("Resend email")}
							</span>
							<BrowserSignalR credentials={credentials} />
						</div>
					) : (
						<>
							<p className="login__message">{props.loginReducer.errorMessage}</p>
							<form onSubmit={handleSubmit(handleLogin)} style={{width: "100%"}}>
								<FormGroup>
									<InputGroup className="login__input-group">
										<input autoComplete="username" {...register("login")} className="form-control login__input" placeholder={t("Login")} />
										<InputGroup addonType="append" className="login__icon-container">
											<FontAwesomeIcon icon={faUser} color="gray" className="login__icon" />
										</InputGroup>
									</InputGroup>
								</FormGroup>
								<FormGroup>
									<InputGroup className="login__input-group">
										<input autoComplete="current-password" {...register("password")} className="form-control login__input" placeholder={t("Password")} type="password" />
										<InputGroup addonType="append" className="login__icon-container">
											<FontAwesomeIcon icon={faKey} color="gray" className="login__icon" />
										</InputGroup>
									</InputGroup>
								</FormGroup>
								{isError && (
									<>
										<FormGroup>
											<div className="captcha-wrapper">
												<LoadCanvasTemplateNoReload />
											</div>
										</FormGroup>
										<FormGroup>
											<InputGroup className="login__input-group">
												<input {...register("captcha")} className="form-control login__input" placeholder={t("Captcha")} />
												<InputGroup addonType="append" className="login__icon-container">
													<img src={captcha} style={{filter: "invert(0.45)"}} className="login__icon" />
												</InputGroup>
											</InputGroup>
										</FormGroup>
									</>
								)}
								<FormGroup>
									<Button className="login__button" color="primary">
										{t("Log in")}
									</Button>
								</FormGroup>
							</form>
						</>
					)
				) : (
					<>
						<p className="login__message">{props.loginReducer.forgotStatus}</p>
						<form onSubmit={handleSubmit(handleForget)}>
							<FormGroup>
								<InputGroup className="login__input-group">
									<input
										{...register("email", {required: t("This field is required"), pattern: {message: t("Invalid email"), value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}})}
										className={errors.email ? "form-control is-invalid login__input" : "form-control login__input"}
										placeholder={t("email")}
									/>
									<InputGroup addonType="append" className="login__icon-container">
										<FontAwesomeIcon icon={faAt} color="gray" className="login__icon" />
									</InputGroup>
								</InputGroup>
								<FormText color="danger">{errors.email?.message}</FormText>
							</FormGroup>
							<FormGroup>
								<Button disabled={buttonDisabled} color="primary" className="login__button">
									{buttonDisabled ? <Spinner /> : t("Send")}
								</Button>
							</FormGroup>
						</form>
					</>
				)}
				{!untrustedBrowser && (
					<FormGroup style={{textAlign: "center"}}>
						<span onClick={toggleForgot} className="login__forgot-text">
							{forgot ? t("Return") : t("Forgot password?")}
						</span>
					</FormGroup>
				)}
			</div>
		</div>
	);
}

const mapStateToProps = (state) => ({
	loginReducer: state.login,
});

const mapDispatchToProps = (dispatch) => ({
	loginUser: (credentials) => {
		dispatch(loginUserAction(credentials));
	},
	forgotPassword: (email) => {
		dispatch(forgotPassword(email));
	},
	tryLogin: () => {
		dispatch(tryLogin());
	},
	setError: (message) => {
		dispatch(loginFailed(message));
	},
	resendEmail: () => {
		dispatch(resendConfirmEmail());
	},
});

Login = connect(mapStateToProps, mapDispatchToProps)(Login);
